import { type Meta } from '../types/docs';
import { ONBOARDING_ANALYTICS_CATEGORY_META_PARAM } from './onboardingAnalytics';

export const COMPLETED_ONBOARDING_INVITE_MEMBERS_ROLES = ['admin', 'commenter', 'editor'] as const;

export type CompletedOnboardingInviteMembersRole = (typeof COMPLETED_ONBOARDING_INVITE_MEMBERS_ROLES)[number];

const META: Meta = {
  description: 'Event sent when a user completes the onboarding invite members step',
  name: 'completed_onboarding_invite_members',
  params: [
    {
      description: 'Selected workspace member role for invited members',
      name: 'role',
      required: true,
      type: 'enum',
      values: [...COMPLETED_ONBOARDING_INVITE_MEMBERS_ROLES],
    },
    {
      description: 'Number of invitations sent from the onboarding invite members step',
      name: 'number_invites',
      required: true,
      type: 'number',
    },
    ONBOARDING_ANALYTICS_CATEGORY_META_PARAM,
  ],
};

export default META;
